export default {
    sendForm(formName, label){
        gtag && gtag('event', formName, {'event_category': 'form', 'event_label': label}); 
    },

    sendLink(href){
        gtag && gtag('event', 'click', {
            'event_category': 'outbound',
            'event_label': href,
            'transport_type': 'beacon'
          }
        ); 
    }
}
